// Enhanced UI components for different save types
import React from 'react';
import { SaveStatus } from '../../hooks/useBCPSavingStrategy';
import BCPSaveButton from './BCPSaveButton';

export const SaveStatusIndicator: React.FC<{ savingStatus: SaveStatus }> = ({ savingStatus }) => {
  if (savingStatus.isAutoSaving) {
    return (
      <div className="flex items-center text-sm text-blue-600">
        <div className="mr-2 w-4 h-4 rounded-full border-2 border-blue-600 animate-spin border-t-transparent"></div>
        Auto-saving...
      </div>
    );
  }

  if (savingStatus.lastSaved) {
    return (
      <div className="flex items-center text-sm text-green-600">
        <svg className="mr-2 w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
        </svg>
        Saved {savingStatus.lastSaved.toLocaleTimeString()}
      </div>
    );
  }

  return null;
};

// Enhanced section save button with better feedback
export const SectionSaveButton: React.FC<{
  section: string;
  onSave: () => Promise<void>;
  savingStatus: SaveStatus;
  disabled?: boolean;
}> = ({ section, onSave, savingStatus, disabled = false }) => {
  return (
    <BCPSaveButton
      section={section}
      onSave={onSave}
      savingStatus={savingStatus}
      disabled={disabled}
    />
  );
};
